import type { NavLink, SiteConfig, TravelOption } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Morrow Golf Park',
    shortName: 'Morrow',
    description: 'An eighteen-hole golf park on the Alentejo coast: a championship course shaped by dune, pine and heath, a clubhouse built from the land, an academy, dining, lodges and membership.',
    url: getOrigin(),
    ogImage: '/images/campaign/coast-peninsula.png'
}

/** Where every booking call to action leads. */
export const BOOKING_HREF = '/visit#booking'

export const primaryNav: NavLink[] = [
    { label: 'Course', href: '/course' },
    { label: 'Clubhouse', href: '/clubhouse' },
    { label: 'Academy', href: '/academy' },
    { label: 'Membership', href: '/membership' },
    { label: 'Dining', href: '/dining' },
    { label: 'Events', href: '/events' },
    { label: 'Contact', href: '/contact' }
]

export const fullNav: NavLink[] = [
    { label: 'Home', href: '/' },
    { label: 'The course', href: '/course' },
    { label: 'Clubhouse', href: '/clubhouse' },
    { label: 'Academy', href: '/academy' },
    { label: 'Membership', href: '/membership' },
    { label: 'Dining & stays', href: '/dining' },
    { label: 'Events', href: '/events' },
    { label: 'Nature & lifestyle', href: '/nature' },
    { label: 'Gallery', href: '/gallery' },
    { label: 'Visit & book', href: '/visit' },
    { label: 'Contact', href: '/contact' }
]

/** The name shown on the page curtain while travelling to a path. */
export const pageLabelFor = (pathname: string): string => {
    return fullNav.find((link) => link.href === pathname)?.label ?? siteConfig.shortName
}

export const contact = {
    email: 'concierge@morrowgolfpark.com',
    addressLines: ['Morrow Golf Park', 'Estrada da Costa', '7570 Grândola, Portugal'],
    coordinates: '38°11′ N · 8°47′ W'
}

export const openingHours: TravelOption[] = [
    { label: 'Championship 18', value: 'Sunrise to sunset' },
    { label: 'The Short Nine', value: 'Until 23:00, floodlit' },
    { label: 'Clubhouse', value: '07:00 to 23:00' }
]

export const travelOptions: TravelOption[] = [
    { label: 'Lisbon Airport', value: '70 min by car' },
    { label: 'Lisbon city centre', value: '65 min by car' },
    { label: 'By helicopter', value: '20 min to the estate helipad' },
    { label: 'The beach', value: '12 min on foot through the dunes' }
]
